import { useTheme } from "@/services/theme";
import type { FC, PropsWithChildren } from "react";

export const ThemeInitializer: FC<PropsWithChildren> = ({ children }) => {
  useTheme();
  return <>{children}</>;
};
